export const JOB_STATUS = {
    PENDING: "pending",
    FILE_UPLOADED: "file_uploaded",
    PROCESSING: "processing",
    FAILED: "failed",
    COMPLETED: "completed",
};